import { Progress } from "antd";

const AssessmentResult = ({ resultAnalysis }) => {
  return (
    <>
      {resultAnalysis.length > 0 && (
        <>
          <div className="result-component">
            <p className="result-component__title">{resultAnalysis[0][0]}</p>
            <p className="result-component__sub-text">
              {resultAnalysis[0][0] === "Arts and Humanities"
                ? "This deals with creative and critical thinking, human behavior,writing, and communications"
                : resultAnalysis[0][0] === "Science"
                ? "This deals with the natural world in its molecular and technological aspects"
                : resultAnalysis[0][0] === "Social Science"
                ? "This deals with human behaviour in its social and cultural aspects"
                : ""}
            </p>
            <div className="result-component__progress">
              <p>{resultAnalysis[0][1]}%</p>
              <Progress percent={resultAnalysis[0][1]} showInfo={false} />
            </div>
          </div>

          <div className="result-component">
            <p className="result-component__title">{resultAnalysis[1][0]}</p>
            <p className="result-component__sub-text">
              {resultAnalysis[1][0] === "Arts and Humanities"
                ? "This deals with creative and critical thinking, human behavior,writing, and communications"
                : resultAnalysis[1][0] === "Science"
                ? "This deals with the natural world in its molecular and technological aspects"
                : resultAnalysis[1][0] === "Social Science"
                ? "This deals with human behaviour in its social and cultural aspects"
                : ""}
            </p>
            <div className="result-component__progress">
              <p>{resultAnalysis[1][1]}%</p>
              <Progress percent={resultAnalysis[1][1]} showInfo={false} />
            </div>
          </div>

          <div className="result-component">
            <p className="result-component__title">{resultAnalysis[2][0]}</p>
            <p className="result-component__sub-text">
              {resultAnalysis[2][0] === "Arts and Humanities"
                ? "This deals with creative and critical thinking, human behavior,writing, and communications"
                : resultAnalysis[2][0] === "Science"
                ? "This deals with the natural world in its molecular and technological aspects"
                : resultAnalysis[2][0] === "Social Science"
                ? "This deals with human behaviour in its social and cultural aspects"
                : ""}
            </p>
            <div className="result-component__progress">
              <p>{resultAnalysis[2][1]}%</p>
              <Progress percent={resultAnalysis[2][1]} showInfo={false} />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AssessmentResult;
